import { useEffect, useState } from "react";
import { MessageCircle, Star } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface Props {
  onAspirasi: () => void;
}

const FloatingAction = ({ onAspirasi }: Props) => {
  const navigate = useNavigate();

  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShow(window.scrollY > 350);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {/* ================= MOBILE ================= */}

      <div
        className={`
          fixed
          bottom-5
          left-1/2
          z-[999]
          w-[92%]
          max-w-sm
          -translate-x-1/2
          transition-all
          duration-500
          md:hidden
          ${show ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-32 opacity-0"}
        `}>
        <div className="flex overflow-hidden rounded-full border border-white/30 bg-white/90 shadow-[0_15px_40px_rgba(132,204,22,.25)] backdrop-blur-xl">
          <button onClick={onAspirasi} className="flex flex-1 items-center justify-center gap-2 py-4 font-semibold text-lime-700 transition hover:bg-lime-50">
            <MessageCircle size={20} />
            Aspirasi
          </button>

          <div className="w-px bg-gray-200" />

          <button onClick={() => navigate("/questionnaire")} className="flex flex-1 items-center justify-center gap-2 py-4 font-semibold text-lime-700 transition hover:bg-lime-50">
            <Star size={20} />
            Kuesioner
          </button>
        </div>
      </div>

      {/* ================= DESKTOP ================= */}

      <div
        className={`
          fixed
          bottom-8
          right-8
          z-[999]
          hidden
          transition-all
          duration-500
          md:block
          ${show ? "translate-x-0 opacity-100" : "pointer-events-none translate-x-40 opacity-0"}
        `}>
        <div className="overflow-hidden rounded-3xl border border-white/40 bg-white/90 shadow-[0_20px_50px_rgba(132,204,22,.20)] backdrop-blur-xl">
          <button
            onClick={onAspirasi}
            className="
              flex
              w-60
              items-center
              gap-4
              px-6
              py-5
              transition
              hover:bg-lime-50
            ">
            <div className="rounded-2xl bg-lime-100 p-3">
              <MessageCircle className="text-lime-700" />
            </div>

            <div className="text-left">
              <h3 className="font-bold text-slate-800">Sampaikan Aspirasi</h3>

              <p className="text-sm text-gray-500">Kritik & saran masyarakat</p>
            </div>
          </button>

          <div className="border-t" />
          <a href="/questionnaire">
            <button
              className="
              flex
              w-60
              items-center
              gap-4
              px-6
              py-5
              transition
              hover:bg-lime-50
            ">
              <div className="rounded-2xl bg-yellow-100 p-3">
                <Star className="text-yellow-500" />
              </div>

              <div className="text-left">
                <h3 className="font-bold text-slate-800">Kuesioner</h3>

                <p className="text-sm text-gray-500">Berikan penilaian Anda</p>
              </div>
            </button>
          </a>
        </div>
      </div>
    </>
  );
};

export default FloatingAction;
